import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { replaceRichText } from 'src/common/utils/text-replace';
import { useGlobalContent } from '../../../hooks';
import RichText from '../../Prismic/RichText';
import './ShippingAddress.scss';

const ShippingAddress = ({ title, address, className }) => {
  const { addressLayout } = useGlobalContent('orders');
  return (
    <div className={cx('shipping-address', {
      [className]: className
    })}>
      <h5 className="text-kilo bold shipping-address__title">{title}</h5>
      <RichText fields={replaceRichText(addressLayout, address)} />
    </div>
  );
};

ShippingAddress.propTypes = {
  title: PropTypes.string.isRequired,
  address: PropTypes.shape({
    firstname: PropTypes.string.isRequired,
    lastname: PropTypes.string.isRequired,
    address1: PropTypes.string.isRequired,
    address2: PropTypes.string.isRequired,
    city: PropTypes.string.isRequired,
    zipcode: PropTypes.string.isRequired,
    country: PropTypes.string.isRequired,
  }).isRequired,
  className: PropTypes.string,
};

export default ShippingAddress;



// WEBPACK FOOTER //
// ./src/client/js/view/components/OrderDetails/ShippingAddress/ShippingAddress.js